import { render, staticRenderFns } from "./DatenauskunftExport.vue?vue&type=template&id=5ec2b48b"
import script from "./DatenauskunftExport.vue?vue&type=script&lang=js"
export * from "./DatenauskunftExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports